<div class="wccard p-3 mb-1">
    <app-companypage-ai *ngIf="attritiondataAI" [hasMedianSalary]="hasJobDemand" [currentCompanyName]="currentCompanyName" [requestaidata]="attritiondataAI" [insightstabname]="'attrition and function'" [totalcount]="totalFunctionResultCount" [dataPending]="getDataPendingStatus()"></app-companypage-ai>
</div>
<div class="wccard p-3 mb-1">
    <p class="f-16 font-weight-600 mb-4">Attrition and Hiring by Function</p>
    <div class="mt-2">
        <table mat-table [dataSource]="functions" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" (matSortChange)="manualSort()"
            matSort #attritionTbSort="matSort">

            <!-- key -->
            <ng-container matColumnDef="key">
                <th class="col-md-4" mat-header-cell mat-header-cell *matHeaderCellDef style="width: 150px;">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj["Role"]}}</p>
                </th>
                <td class="col-6 text-484b59" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                    {{element.key | titlecase}}
                </td>
            </ng-container>

            <!-- attrition -->
            <ng-container matColumnDef="attrition">
                <th class="text-center col-2" mat-header-cell *matHeaderCellDef mat-sort-header
                    sortActionDescription="Sort by doc count" style="width: 200px;">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj["Attrition"]}}</p>
                </th>
                <td mat-cell *matCellDef="let element" class="col-2 text-484b59">
                    <div class="d-flex align-items-center justify-content-center">
                        <span class="flex-shrink-0 mr-4 text-484b59" style="width: 70px">{{element?.attrition}}%</span>
                        <div class="flex-grow-1 position-relative">
                            <div class="progress">
                                <div class="progress-bar" role="progressbar" style="background-color: #2E93A1 !important;"
                                    [ngStyle]="{'width.%': element?.attrition}"
                                    aria-valuenow="element?.attrition" aria-valuemin="0" aria-valuemax="100">
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="hirecount">
                <th class="col-2" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj["Hiring"]}}</p>
                </th>
                <td class="col-2 text-484b59" mat-cell *matCellDef="let element">{{element?.hirecount}}%</td>
            </ng-container>

                <ng-container matColumnDef="job_doc_count">
        <th class="" *matHeaderCellDef mat-header-cell>
          <p class="text-9696 f-12 m-0" [ngbTooltip]="jobdemand">{{tableHeaderObj['JobDemand']}}</p>
            <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
        </th>
        <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
          <div *ngIf="hasJobDemand" class="spinner-border position-absolute text-black" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span class="" (click)="hasJobListingAccess &&  openJoblistSlider(element.key)" [class.pointer]="hasJobListingAccess" *ngIf="element?.job_doc_count != 0">{{element?.job_doc_count | number}}</span>
          <span class="" *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>
         </td>
      </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <!-- <p class="text-center text-webbtree-green f-14 font-weight-500 my-4" *ngIf="functions?.filteredData && functions?.filteredData?.length > 4"><span class="pointer" (click)="viewMore('function')">{{isViewMore}}</span></p> -->
        <!-- <div *ngIf="functions == null || functions.length == 0">
            <p class="text-center small p-5">No data to display</p>
        </div> -->
        <div *ngIf="!functions?.filteredData?.length">
            <div class="loader text-center" *ngIf="!attritionemptystate">
                <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
            </div>
            <div class="text-center" *ngIf="attritionemptystate">
                <p class="text-center small p-5 text-484b59">No Data Available</p>
            </div>
        </div>

    </div>
</div>
<div class="d-flex justify-content-center wccard ng-star-inserted mb-2" *ngIf="totalCountFunction > 5">
    <ngb-pagination [collectionSize]="totalCountFunction" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSizeFunction" rotate="false" (pageChange)="setPageFunction($event)" [(page)]="currentPageFunction" [ellipses]="false" [boundaryLinks]="false"
  [directionLinks]="false">
    </ngb-pagination>
</div>

<div class="wccard p-3 mb-1">
    <div class="d-flex align-items-baseline justify-content-between mb-4">
        <div class="d-flex align-items-baseline">
            <p class="f-16 font-weight-600 mr-4">Recent Attrition in last</p>
            <div>
                <select data-testid="auto-app-attrtion-tab-select-1" class="newSelectInput" (change)="filterselected($event,'recentAttrition')"
                [(ngModel)]="selectedMonthsRecentAttrition">
                    <option value="3">3 Months</option>
                    <option value="6">6 Months</option>
                    <option value="9">9 Months</option>
                    <option value="12">12 Months</option>
                </select>
            </div>
        </div>
        <button data-testid="auto-app-attrtion-tab-button-1" *ngIf="recentAttrition.length" class="text-webbtree-green font-weight-600" style="border: none; background: transparent;" (click)="handelRedirection('recentAttrtion', null)">View All</button>
    </div>
    <div>
        <p class="text-9696 f-14 mb-2">Total Candidates ({{totalCountAttrtion | number}})</p>
    </div>
    <div class="d-flex flex-wrap mb-2" *ngIf="recentAttrition && recentAttrition.length">
        <div class="col-4 mb-2 pl-0 pr-2" *ngFor="let candidateDetails of recentAttrition; let i = index">
           <app-candidate-card-view [candidateDetails]="candidateDetails" [i]="i"></app-candidate-card-view>
        </div>
    </div>
    <div *ngIf="!recentAttrition.length">
        <div class="loader text-center" *ngIf="recentAttiritonPending">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div class="text-center" *ngIf="!recentAttiritonPending">
            <p class="text-center small p-5 text-484b59">No Data Available</p>
        </div>
    </div>
</div>
<div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCountAttrtion > 5">
    <ngb-pagination [collectionSize]="totalCountAttrtion" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSizeAttrtion" rotate="false" (pageChange)="setPageAttrtion($event)" [(page)]="currentPageAttrtion" [ellipses]="false" [boundaryLinks]="false"
  [directionLinks]="false">
    </ngb-pagination>
</div>

<div class="wccard p-3 mb-1 mt-2">
    <div class="d-flex align-items-baseline justify-content-between mb-4">
        <div class="d-flex align-items-baseline">
            <p class="f-16 font-weight-600 mr-4">Recent Hires in last</p>
            <div>
                <select data-testid="auto-app-attrtion-tab-select-2" class="newSelectInput" (change)="filterselected($event,'recentHire')"
                [(ngModel)]="selectedMonth">
                    <option value="3">3 Months</option>
                    <option value="6">6 Months</option>
                    <option value="9">9 Months</option>
                    <option value="12">12 Months</option>
                </select>
            </div>
        </div>
        <button data-testid="auto-app-attrtion-tab-button-2" *ngIf="recentHiresData?.length" class="text-webbtree-green font-weight-600" style="border: none; background: transparent;" (click)="handelRedirection('recentGrowth', null)">View All</button>
    </div>
    <div>
        <p class="text-9696 f-14 mb-2">Total Candidates ({{totalRecentHiresCount | number}})</p>
    </div>
    <div class="d-flex flex-wrap mb-2" *ngIf="recentHiresData?.length">
        <div class="col-4 mb-2 pl-0 pr-2" *ngFor="let candidateDetails of recentHiresData; let i = index">
           <app-candidate-card-view [candidateDetails]="candidateDetails" [i]="i"></app-candidate-card-view>
        </div>
    </div>
    <div *ngIf="!recentHiresData.length">
        <div class="loader text-center" *ngIf="recentHiresPending">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div class="text-center" *ngIf="!recentHiresPending">
            <p class="text-center small p-5 text-484b59">No Data Available</p>
        </div>
    </div>
</div>
<div class="d-flex justify-content-center wccard" *ngIf="totalRecentHiresCount > 6">
    <ngb-pagination [collectionSize]="totalRecentHiresCount" [maxSize]="5" aria-label="Custom pagination" [pageSize]="recentHirePageSize" rotate="false" (pageChange)="setPageRecentHire($event)" [(page)]="recentHireCurrentPage" [ellipses]="false" [boundaryLinks]="false"
  [directionLinks]="false">
    </ngb-pagination>
</div>
<app-insights-joblist [data]="toOpenSliderFromTabSubject.asObservable()" [events]="sendDataToSliderSubject.asObservable()"></app-insights-joblist>
